export default "__VITE_ASSET__C_A0Dx0i__"